const data = [
  {
    align: "alignLeft",
    cardTxt:
      "Our project Augnex-AR based campus navigation was displayed in Engineer’s Conclave in Inter IIT Tech Meet 9.0.",
    cardImg: "https://iit-techambit.in/content/images/2021/04/logo-9.0.png"
  },
  {
    align: "alignRight",
    cardTxt:
      "Three of our club teams qualified for the final rounds of Sustain and Spottle ai Challenge in IIMA; The Red Brick Summit.",
    cardImg:
      "https://students.iima.ac.in/trbs/upload/main_trbs_41Logo1625768081.png"
  },
  {
    align: "alignLeft",
    cardTxt:
      "Our club member Aryaman Joshi was a part of the 6 member team which participated in the Mid-prep event- Agrobot Design Innovation Challenge in Inter IIT Tech Meet 9.0. The team missed the bronze medal by a very small margin.",
    cardImg: "https://iit-techambit.in/content/images/2021/04/logo-9.0.png"
  },
  {
    align: "alignRight",
    cardTxt:
      "Our club members Vaishnavi Tiwari and Ishika Mittal stood first in Decipher- Product Development Challenge conducted by Testbook.",
    cardImg:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4Po5T7bt8RJHQ_HfWf67kznPkM16CFx9Ct872GVpxh5hRLtQWWs0ABfC3Y8iI1l5guzc&usqp=CAU"
  },
  {
    align: "alignLeft",
    cardTxt:
      "Our club member Kshitij Sinha was a part of a 9 member team which bagged a Gold medal in high prep event- Drishtee Tech-Ied innovation for rural entrepreneurs in Inter IIT Tech Meet 9.0.",
    cardImg: "https://iit-techambit.in/content/images/2021/04/logo-9.0.png"
  }
]

export default data
